var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("a-html", { attrs: { autoEnable: "false" } }, [
    _c("div", { staticClass: "vr" }, [
      _c("p", [
        _c(
          "svg",
          {
            staticStyle: { width: "3em", height: "3em" },
            attrs: {
              version: "1.1",
              xmlns: "http://www.w3.org/2000/svg",
              "xmlns:xlink": "http://www.w3.org/1999/xlink",
              x: "0px",
              y: "0px",
              viewBox: "0 0 48 35",
              "enable-background": "new 0 0 48 35",
              "xml:space": "preserve",
            },
          },
          [
            _c(
              "g",
              {
                attrs: { id: "Group_101", transform: "translate(-1076 -134)" },
              },
              [
                _c("path", {
                  attrs: {
                    id: "Path_25",
                    fill: "#FFFFFF",
                    d: "M1076,169h13.456l10.749-35h-10.749L1076,169z",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    id: "Path_26",
                    fill: "#FFFFFF",
                    d: "M1099.795,169h13.456L1124,134h-10.749L1099.795,169z",
                  },
                }),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "vr-quote",
        domProps: { innerHTML: _vm._s(_vm.block.field_values.html) },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "vr-quote-author" }, [
        _vm._v(
          "\n        — " + _vm._s(_vm.block.field_values.text) + "\n      "
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }